import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=a52a98e4&scoped=true"
import script from "./FilterCard.vue?vue&type=script&lang=js"
export * from "./FilterCard.vue?vue&type=script&lang=js"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=a52a98e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a98e4",
  null
  
)

export default component.exports